/** @jsx jsx */
import React, { useEffect, Fragment } from "react";
import { useMachine } from "@xstate/react";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Flex } from "rebass";
import { jsx } from "@emotion/core";
import { Box, RadioGroup, FormLabel } from "@material-ui/core";

import StepContainer from "../StepContainer";
import CurrencyInput from "../CurrencyInput";
import Text from "../Text";
import Button from "../Button";

import { getStep5 } from "./machine";

function Step5({ listingType, reservePrice, buyNowPrice, onSubmit, onBack }) {
  const [current, send] = useMachine(
    getStep5({
      listingType,
      reservePrice,
      buyNowPrice,
    })
  );

  const finished = current.matches("finished");

  useEffect(() => {
    finished && onSubmit(current.context);
  }, [finished, current.context, onSubmit]);

  return (
    <StepContainer title="Step 5 / 5: How You'd Like To Sell It">
      <FormLabel required component="legend">
        Equipment Type
      </FormLabel>
      <RadioGroup
        aria-label="listing type"
        name="listingType"
        value={current.context.listingType}
        onChange={(e: React.FormEvent<HTMLInputElement>) => {
          send("INPUT_LISTING_TYPE", {
            listingType: e.currentTarget.value,
          });
        }}
        // hasError={current.matches("ready.listingType.error")}
        // errorMessage="Listing Type is a required field"
      >
        <Box mt={1} />
        <FormControlLabel
          value="buyNow"
          control={<Radio />}
          label={
            <Fragment>
              Buy Now with Make Offer
              <Text style={{ fontSize: 12 }}>
                Your equipment will be listed at the price you set. Buyers will
                be able to send you offers.
              </Text>
            </Fragment>
          }
        />
        <FormControlLabel
          value="absoluteAuction"
          control={<Radio />}
          label={
            <Fragment>
              Absolute Auction
              <Text style={{ fontSize: 12 }}>
                Your equipment will sell to the highest bidder - no matter the
                amount.
              </Text>
            </Fragment>
          }
        />
        <FormControlLabel
          value="reserveAuction"
          control={<Radio />}
          label={
            <Fragment>
              Reserve Auction
              <Text style={{ fontSize: 12 }}>
                Your equipment will sell to the highest bidder - should your
                reserve price be met.
              </Text>
            </Fragment>
          }
        />
      </RadioGroup>
      {current.context.listingType === "reserveAuction" && (
        <Flex flexDirection="column">
          <CurrencyInput
            required
            errorMessage={"Reserve price is a required field."}
            error={current.matches("ready.reservePrice.error")}
            label={
              <span>
                Reserve Price <small>USD</small>
              </span>
            }
            allowLeadingZeroes
            name="reservePrice"
            current={current}
            value={reservePrice}
            onChange={(e: React.FormEvent<HTMLInputElement>) => {
              send("INPUT_RESERVE_PRICE", {
                reservePrice: e.currentTarget.value,
              });
            }}
          />
          <Text style={{ marginTop: 10 }}>
            <strong>Please keep in mind the 10% seller’s fee.</strong>
          </Text>
        </Flex>
      )}
      {current.context.listingType === "buyNow" && (
        <Flex flexDirection="column">
          <CurrencyInput
            required
            errorMessage={"Buy Now price is a required field."}
            error={current.matches("ready.buyNowPrice.error")}
            value={buyNowPrice}
            allowLeadingZeroes={true}
            label={
              <span>
                Buy Now Price <small>USD</small>
              </span>
            }
            name="buyNowPrice"
            current={current}
            onChange={(e: React.FormEvent<HTMLInputElement>) => {
              send("INPUT_BUY_NOW_PRICE", {
                buyNowPrice: e.currentTarget.value,
              });
            }}
          />
          <Text style={{ marginTop: 10 }}>
            <strong>Please keep in mind the 10% seller’s fee.</strong>
          </Text>
        </Flex>
      )}
      <Flex justifyContent="space-between" mt="4">
        <Button onClick={() => onBack(current.context)} width={200}>
          Back
        </Button>

        <Button
          onClick={() => {
            send("SUBMIT");
          }}
          width={200}
          color="primary"
        >
          Submit
        </Button>
      </Flex>
    </StepContainer>
  );
}

export default Step5;
